import { render, staticRenderFns } from "./IdentityPortrait.vue?vue&type=template&id=4f611d66&scoped=true&"
import script from "./IdentityPortrait.vue?vue&type=script&lang=js&"
export * from "./IdentityPortrait.vue?vue&type=script&lang=js&"
import style0 from "./IdentityPortrait.vue?vue&type=style&index=0&id=4f611d66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f611d66",
  null
  
)

export default component.exports